export default {"link":"jujmm","title":"hcxdp","date":"m3seM"};